/* ==========================================================================
   nl-modal.js — one shared, event-delegated modal behavior for mt- sections.
   No per-instance init (delegation survives Shopify section reloads).

   Markup contract:
     <button data-nl-modal-trigger aria-controls="THE_MODAL_ID"> … </button>
     <div id="THE_MODAL_ID" data-nl-modal aria-hidden="true" role="dialog" aria-modal="true">
       <div data-nl-modal-close></div>          <!-- overlay (click to close) -->
       <div> … <button data-nl-modal-close>×</button> … </div>
     </div>
   Open state is the `data-open` attribute (CSS shows the modal on [data-open]).
   Closes on: close/overlay click, Escape. Locks body scroll while open,
   restores focus to the trigger on close.
   ========================================================================== */
(function () {
  'use strict';

  function open(modal) {
    if (!modal) return;
    modal.__mtReturn = document.activeElement;
    modal.setAttribute('data-open', '');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closer = modal.querySelector('[data-nl-modal-close]');
    if (closer && closer.focus) closer.focus();
  }

  function close(modal) {
    if (!modal) return;
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-nl-modal][data-open]')) document.body.style.overflow = '';
    var ret = modal.__mtReturn;
    if (ret && ret.focus) ret.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nl-modal-trigger]');
    if (trigger) {
      var id = trigger.getAttribute('aria-controls');
      var modal = id && document.getElementById(id);
      if (modal) { e.preventDefault(); open(modal); }
      return;
    }
    var closer = e.target.closest('[data-nl-modal-close]');
    if (closer) { close(closer.closest('[data-nl-modal]')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModal = document.querySelector('[data-nl-modal][data-open]');
    if (openModal) close(openModal);
  });

  // If a section is removed in the editor while its modal is open, release the lock.
  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector('[data-nl-modal][data-open]')) document.body.style.overflow = '';
  });
})();
